import { Route } from "react-router-dom";
import { LayoutTemplateV2 } from "../components/Templates/LayoutTemplateV2";
import { ProtectedClientRoute } from "../components/Atoms/ProtectedClientRoute";
import { ServicesV2 } from "../components/Pages/ServicesV2";
import { BatchSpreadsheetImport } from "../components/Pages/BatchSpreadsheetImport";
import { BatchCreatedAppointments } from "../components/Pages/BatchCreatedAppointments";

export const useAgendamentoLoteByIdRoutes = () => {
  return (
    <Route path="/agendamento-lote/:uuidAgendamento" element={<LayoutTemplateV2 />}>
      <Route path="servicos">
        <Route
          index
          element={
            <ProtectedClientRoute>
              <ServicesV2 />
            </ProtectedClientRoute>
          }
        />
        <Route
          path=":tipoServico"
          element={
            <ProtectedClientRoute>
              <BatchSpreadsheetImport />
            </ProtectedClientRoute>
          }
        />
      </Route>
      <Route
        path="agendamentos-criados"
        element={
          <ProtectedClientRoute>
            <BatchCreatedAppointments />
          </ProtectedClientRoute>
        }
      />
    </Route>
  );
};
